import {translateId, translateIdInOtherLang, translateMessage} from "../../common/Translator";
import * as CommonConstants from "../../constants/CommonConstants";
import {describe, getFunctionShortCut} from "../../common/ShortCutsUtil";
import {areNotEqual} from "../../common/NamaCommon";

export class MoreMenuItem {
    /**
     *
     * @param {string} id
     * @param {string} title
     * @param {EditPresenter} presenter
     * @param {Function} action
     * @param {string} parentButtonId
     */
    constructor(id, presenter, clickFunction, title, subItems, customization) {
        this.id = id;
        if (customization && customization.securityID)
            this.securityID = customization.securityID;
        this.presenter = presenter;
        if (title) {
            this.title = title;
        } else if (areNotEqual(id, CommonConstants.MORE_MENU_SEPERATOR)) {
            this.title = translateId(id);
            this.otherTitle = translateIdInOtherLang(id);
        }
        let shortCut = getFunctionShortCut(id);
        if (shortCut) {
            this.title += describe(shortCut);
        }
        this.items = subItems;
        if (!subItems) {
            if (clickFunction)
                this.clickFunction = clickFunction;
            else
                this.clickFunction = () => presenter.callGUIAction(id, presenter.metaData, customization);
        }
    }
}

export function separator(presenter) {
    return new MoreMenuItem(CommonConstants.MORE_MENU_SEPERATOR, presenter, function () {

    });
}